import { Component, OnInit } from '@angular/core';
import { GroupService } from '../../services/group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SpecialPermissions } from '../../services/permission.service';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-special-permissions',
  templateUrl: './special-permissions.component.html',
  styleUrls: ['./special-permissions.component.css']
})
export class SpecialPermissionsComponent implements OnInit {

  groupId: string = '';
  groupName: string = '';
  specialPermissions: any = {};

  constructor(
    private groupService: GroupService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.groupId = activatedRoute.snapshot.paramMap.get('groupId');
    let sub = this.groupService.getGroup(this.groupId).subscribe(({specialPermissions={}, name}) => {
      sub.unsubscribe();
      this.groupName = name;
      this.specialPermissions = {
        ...Object.keys(this.spEnum).reduce((acc, cur) => { acc[cur] = false; return acc; }, {}),
        ...specialPermissions
      }
    });
  }

  ngOnInit() {
  }

  onSubmit(){
    let {specialPermissions} = this;
    this.groupService.putGroup({specialPermissions}, this.groupId);
    this.router.navigate(['permissions']);
  }

  get spEnum() { return SpecialPermissions }
  get spArray() { return Object.keys(this.spEnum); }

}
